import React from "react";
import { Route, Routes } from "react-router-dom";
import Chat from "./pages/Chat";
import EmptyChat from "./pages/EmptyChat";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Root from "./pages/Root";
import Splash from "./pages/Splash";

function App() {
    return (
        <Routes>
            <Route path="/" element={<Root />}>
                <Route index element={<Splash />} />
                <Route path="login" element={<Login />} />
                <Route path="home" element={<Home />}>
                    <Route path=":channel/:chatId/:name" element={<Chat />} />
                    <Route path=":channel/:chatId" element={<Chat />} />
                    <Route index element={<EmptyChat />} />
                </Route>
            </Route>
        </Routes>
    );
}

export default App;
